import { ApiClient } from "@/lib/client";

export const fetchPreviewTokenApi = async () => {
    const res = await ApiClient.get("/core/tenant/get_media_url_token/");
    return res.data.data;
};